import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

/** Returns `false` during SSR and `true` on the client after hydration. */
export function useIsClient() {
  return useSyncExternalStore(emptySubscribe, () => true, () => false);
}
